import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Accordion, Button } from 'react-bootstrap';

const AccordionBox = () => {


    return (
        <>
            <div className=''>
                {/* <Accordion defaultActiveKey={['0']} alwaysOpen> */}
                <Accordion defaultActiveKey={['']} >
                    <Accordion.Item eventKey="0" className='mb-3'>
                        <Accordion.Header><div className='fs-4 text-primary'>Lorem ipsum dolor sit amet consectetur.</div></Accordion.Header>
                        <Accordion.Body className='fs-5 pt-2 px-3'>
                            <p className='text-black fs-5 mb-1'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1" className='mb-3 fs-5'>
                        <Accordion.Header><div className='fs-4 text-primary' >Lorem ipsum dolor sit amet consectetur.</div></Accordion.Header>
                        <Accordion.Body className='fs-5 pt-2 px-3'>
                            <p className='text-black fs-5 mb-1'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2" className='mb-3 fs-5'>
                        <Accordion.Header><div className='fs-4 text-primary'>Lorem ipsum dolor sit amet consectetur.</div></Accordion.Header>
                        <Accordion.Body className='fs-5 pt-2 px-3'>
                            <p className='text-black fs-5 mb-1'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3" className='mb-3 fs-5'>
                        <Accordion.Header><div className='fs-4 text-primary'>Lorem ipsum dolor sit amet consectetur.</div></Accordion.Header>
                        <Accordion.Body className='fs-5 pt-2 px-3'>
                            <p className='text-black fs-5 mb-1'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4" className='mb-3 fs-5'>
                        <Accordion.Header><div className='fs-4 text-primary'>Lorem ipsum dolor sit amet consectetur.</div></Accordion.Header>
                        <Accordion.Body className='fs-5 pt-2 px-3'>
                            <p className='text-black fs-5 mb-1'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5" className='mb-3 fs-5'>
                        <Accordion.Header><div className='fs-4 text-primary'>Lorem ipsum dolor sit amet consectetur.</div></Accordion.Header>
                        <Accordion.Body className='fs-5 pt-2 px-3'>
                            <p className='text-black fs-5 mb-1'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</p>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>

            {/* <div className=' mt-5'>
                <Button variant="custombtn4" className='text-uppercase px-5 py-2' style={{ letterSpacing: "1.1px" }}>Load More</Button>
            </div> */}
        </>
    );
}

export default AccordionBox